import { FilterDateSelectValue } from '../../entities/filterDateSelect/filter-date-select-value';
import { StateValidator } from '../../services/filter-state/filter-state.service';

export interface IssueListFilterState {
  tabIndex: number;
  issueTypeCodes: string[];
  issueStatusCodes: string[];
  assigneeIds: string[];
  locationIds: string[];
  dueDate: FilterDateSelectValue | null;
  labelIds: string[];
  sort: {
    key: string;
    direction?: 'asc' | 'desc';
  };
  pageSize: number;
}

export const DEFAULT_ISSUE_LIST_FILTER_STATE: IssueListFilterState = {
  tabIndex: 0,
  issueTypeCodes: [],
  issueStatusCodes: [],
  assigneeIds: [],
  locationIds: [],
  dueDate: null,
  labelIds: [],
  sort: { key: 'lastModifiedDate', direction: 'desc' },
  pageSize: 15
};

export const isValidIssueListFilterState: StateValidator<IssueListFilterState> = (
  obj: unknown
): obj is IssueListFilterState => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  const state = obj as Record<string, unknown>;
  if (typeof state.tabIndex !== 'number') return false;
  if (!Array.isArray(state.issueTypeCodes)) return false;
  if (!Array.isArray(state.issueStatusCodes)) return false;
  if (!Array.isArray(state.assigneeIds)) return false;
  if (!Array.isArray(state.locationIds)) return false;
  if (!Array.isArray(state.labelIds)) return false;
  if (typeof state.pageSize !== 'number') return false;
  if (state.dueDate !== null && typeof state.dueDate !== 'object') return false;
  if (!state.sort || typeof state.sort !== 'object') return false;
  const sort = state.sort as Record<string, unknown>;
  if (typeof sort.key !== 'string') return false;
  return true;
};
